import React, {useCallback} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {showSnackbar} from 'utils'

const StyledInfoItem = styled.div`
  width: 50%;
`

const StyledCopyIcon = styled(Icon)`
  width: ${convertUnit(8)};
  height: ${convertUnit(8)};
  margin-right: ${convertUnit(8)};
  cursor: pointer;
`

export default function CopyInvoice({
  invoice_id,
  context = 'multiple',
}: {
  invoice_id: string
  context?: 'single' | 'multiple'
}) {
  const {translate} = useTranslation()

  const copyInvoiceToClipboard = useCallback(() => {
    navigator.clipboard.writeText(invoice_id)
    showSnackbar(translate('global:invoiceCopied'))
  }, [invoice_id, translate])

  return (
    <StyledInfoItem
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: context === 'single' ? 'flex-start' : 'flex-end',
        alignItems: 'center',
      }}>
      <Paragraph
        color="primary_5"
        fontSize={context === 'single' ? 'm' : 'xs'}
        style={{
          textAlign: context === 'single' ? 'left' : 'right',
        }}>
        {invoice_id}
      </Paragraph>
      <StyledCopyIcon
        type="copy"
        onClick={(e) => {
          e.stopPropagation()
          copyInvoiceToClipboard()
        }}
        color="primary_5"
        size={12}
      />
    </StyledInfoItem>
  )
}
